<template>
  <div class="code-link-edit">
    <!-- link-->
    <edit-link
      :ids="ids"
      :attrs="attrs"
      :partsContainerType="partsContainerType"
      @change="change($event)"
    />
  </div>
</template>

<script>
import EditLink from '@/components/Content/Palette/EditPartDesign/Layouts/EditLink'

export default {
  props: [
    'codePartNodeIndex',
    'href',
    'title',
    'target',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partId'
  ],
  components: {
    EditLink
  },
  computed: {
    attrs () {
      return {
        href: this.href,
        title: this.title,
        target: this.target || '_top',
        'data-link-kind': this.getLinkKind(this.href),
      }
    },
    ids () {
      return {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId
      }
    },
  },
  methods: {
    getLinkKind (href) {
      // URL未設定の場合、リンク種類はなし
      if (!href) return null
      // リンク先がmailto: から始まったらメールアドレス
      const emailPattern = new RegExp(/^mailto:.*$/)
      const telPattern = new RegExp(/^tel:.*$/)
      if (emailPattern.test(href)) {
        return 'email'
      } else if (telPattern.test(href)) {
        return 'tel'
      } else {
        return 'web'
      }
    },
    change (event) {
      this.$emit('change', {
        nodeIndex: this.codePartNodeIndex,
        type: 'link',
        ...event.attrs
      })
    }
  },
}
</script>
